import { Component, ElementRef, HostBinding, Inject, OnInit, Renderer2, ViewChild } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { CustomMarkdownDirective } from '../../directives/custom-markdown.directives'

export interface DialogData {
    title: string
    text: string
    confirm: string
    cancel: string
}

@Component( {
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['../../app.component.scss', './confirm-dialog.component.scss']
} )
export class ConfirmDialogComponent implements OnInit {

    @ViewChild( 'text' ) text: ElementRef
    @ViewChild( 'title' ) title: ElementRef
    @HostBinding( 'attr.customMarkdown' ) customMarkDownText
    @HostBinding( 'attr.customMarkdown' ) customMarkDownTitle

    constructor ( public dialogRef: MatDialogRef<ConfirmDialogComponent>,
                  public renderer: Renderer2,
                  @Inject( MAT_DIALOG_DATA ) public data: DialogData
    ) {
    }

    ngOnInit () {
        this.customMarkDownText = new CustomMarkdownDirective( this.text, null )
        this.customMarkDownTitle = new CustomMarkdownDirective( this.title, null )
    }

    ngAfterViewInit () {
        this.customMarkDownText.executeMarkDown( this.text, this.renderer )
        this.customMarkDownTitle.executeMarkDown( this.title, this.renderer )
    }

    onConfirm (): void {
        this.dialogRef.close( { res: true } )
    }

    onCancel (): void {
        this.dialogRef.close( { res: false } )
    }

}
